import React from 'react';
import styles from '../../styles/UserPage.module.css';

const PersonasTab = ({
  MAX_PERSONAS,
  handleResetPersonasToDefault,
  personas,
  handleResetSinglePersonaToDefault,
  handleRemovePersona,
  handlePersonaFieldChange,
}) => {
  return (
    <div className={styles.section}>
      <h2 className={styles.sectionTitle}>Personas</h2>
      <p className={styles.sectionDescription}>
        Create up to {MAX_PERSONAS} personas for your swarm sub-agents. Each persona needs a title and a prompt that describes perspective,
        style, and priorities.
      </p>

      <div style={{ marginBottom: '0.75rem' }}>
        <button type="button" onClick={() => void handleResetPersonasToDefault()} className={styles.button}>
          Restore All Default Personas
        </button>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        {personas.map((persona, idx) => (
          <div
            key={persona.sort_order ?? idx}
            style={{
              border: '1px solid var(--input-border)',
              borderRadius: '6px',
              padding: '0.75rem',
              background: 'var(--input-background)',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.45rem' }}>
              <p style={{ margin: 0, fontSize: '0.8rem', color: 'var(--secondary-text-color)' }}>Persona {idx + 1}</p>
              {idx < 3 ? (
                <button
                  type="button"
                  onClick={() => void handleResetSinglePersonaToDefault(idx)}
                  style={{
                    fontSize: '0.75rem',
                    padding: '2px 8px',
                    cursor: 'pointer',
                    border: '1px solid var(--input-border)',
                    borderRadius: '4px',
                    background: 'transparent',
                    color: 'var(--text-color)',
                  }}
                >
                  Restore Default
                </button>
              ) : persona.title || persona.prompt ? (
                <button
                  type="button"
                  onClick={() => void handleRemovePersona(idx)}
                  style={{
                    fontSize: '0.75rem',
                    padding: '2px 8px',
                    cursor: 'pointer',
                    border: '1px solid var(--input-border)',
                    borderRadius: '4px',
                    background: 'transparent',
                    color: 'var(--error-color, #c0392b)',
                  }}
                >
                  Remove
                </button>
              ) : null}
            </div>
            <input
              type="text"
              value={persona.title || ''}
              onChange={(e) => handlePersonaFieldChange(idx, 'title', e.target.value)}
              className={styles.input}
              placeholder="Title (e.g., Career Coach, Finance Planner, Wellness Guide)"
              style={{ marginBottom: '0.5rem' }}
            />
            <textarea
              value={persona.prompt || ''}
              onChange={(e) => handlePersonaFieldChange(idx, 'prompt', e.target.value)}
              className={styles.input}
              rows={4}
              placeholder="Prompt describing this persona's tone, expertise, and reasoning style"
              style={{ resize: 'vertical' }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PersonasTab;
